module.exports = __webpack_public_path__ + "img/seller_add post.301f7db5.svg";